import { GET_LOGS, LOGS_ERROR } from "../types";

const LogsReducer = (state, action) => {
  switch (action.type) {
    case GET_LOGS:
      return { ...state, logs: action.payload };

    case LOGS_ERROR:
      return { ...state, logs_error: action.payload };

    default:
      return state;
  }
};

export default LogsReducer;